import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import SurveyDropDown from './surveyDropDown';
import IndicatorDropDown from './indicatorDropDown';
import {
  selectedIndicator as indicator,
  selectedSurvey as survey,
  surveys as allSurveys,
} from '../../store/slices/modelSurfaceSlice';
import { S3_SUB_BUCKET_PATH, URL_CONFIG } from '../../config/config';

export default function DropDown() {
  const selectedIndicator = useSelector(indicator);
  const selectedSurvey = useSelector(survey);
  const surveys = useSelector(allSurveys);
  const [isBtnDisabled, setIsBtnDisabled] = useState(false);

  useEffect(() => {
    if (selectedSurvey.name === 'all_countries' && selectedIndicator.Label === 'all_indicators') {
      setIsBtnDisabled(true);
    } else {
      setIsBtnDisabled(false);
    }
  }, [selectedIndicator, selectedSurvey]);

  function handleDownloadAll() {
    let package_all_url;

    if (selectedIndicator.Label === 'all_indicators') {
      let slug = surveys.find((survey) => survey.name === selectedSurvey.name).slug;
      slug = slug.split('|').join('');
      package_all_url = `${URL_CONFIG}/${S3_SUB_BUCKET_PATH}/${slug}_package_all.zip`;
    } else {
      //If in development use test bucket , if "prod" use production bucket
      package_all_url = `${URL_CONFIG}/${S3_SUB_BUCKET_PATH}/${selectedIndicator.SDRID}_package_all.zip`;
    }
    window.open(package_all_url);
  }

  return (
    <div className='flex space-between main-conent'>
      <SurveyDropDown />
      <IndicatorDropDown />
      <div className='download-btn-container' onClick={handleDownloadAll}>
        <button
          className={
            isBtnDisabled
              ? 'download download--orange download-all download-disabled'
              : 'download download--orange download-all'
          }
          disabled={isBtnDisabled}
          title={isBtnDisabled ? 'Not Available for Download' : ''}
        >
          DOWNLOAD ALL
        </button>
      </div>
    </div>
  );
}
